import api from './api';

export const whatsappApi = {
  getConversations: async () => {
    const response = await api.get('/whatsapp/conversations');
    return response.data;
  },

  createConversation: async (data) => {
    const response = await api.post('/whatsapp/conversations', data);
    return response.data;
  },

  getMessages: async (conversationId) => {
    const response = await api.get(`/whatsapp/conversations/${conversationId}/messages`);
    return response.data;
  },

  sendMessage: async (conversationId, content) => {
    const response = await api.post('/whatsapp/send', { conversationId, content });
    return response.data;
  },

  assignConversation: async (conversationId, assignedTo) => {
    const response = await api.patch(`/whatsapp/conversations/${conversationId}/assign`, { assignedTo });
    return response.data;
  }
};
